@for (line of lines; track line) {
  <p
    class="p1 col-12">
    @for (field of line; track field) {
      {{ field }}
    }
  </p>
}
@if (telephone) {
  <p class="p1 m-t-6 col-12"
  >{{ telephone }}</p>
}